var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 4.75,
    width: 14.5,
    height: 14.5,
    rx: 3,
    stroke: "#004222",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.75V6",
    stroke: "#004222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.75V6",
    stroke: "#004222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75H19.5",
    stroke: "#004222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 12.75,
    r: 0.75,
    fill: "#004222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 15.75,
    r: 0.75,
    fill: "#004222"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.75,
    r: 0.75,
    fill: "#004222"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15.75,
    r: 0.75,
    fill: "#004222"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 12.75,
    r: 0.75,
    fill: "#004222"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15.75,
    r: 0.75,
    fill: "#004222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlank);
export default __webpack_public_path__ + "static/media/calendarBlank.d8a4f6f7bbd260a7ed47a94d879f9724.svg";
export { ForwardRef as ReactComponent };